import axios from 'axios';

// Determina il baseURL in base all'ambiente
const determineBaseUrl = () => {
  // In ambiente di sviluppo, usiamo l'URL del backend specifico
  // In produzione sul server, usiamo una stringa vuota per evitare duplicazioni
  if (process.env.REACT_APP_TYPE === 'DEV') {
    // In dev usiamo esplicitamente il backend su porta 5001
    return process.env.REACT_APP_API_URL || 'http://localhost:5000';
  } else {
    // In prod useremo l'URL relativo
    return '';
  }
};

const axiosInstance = axios.create({
  baseURL: determineBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interceptor per aggiungere /api alle URL in qualsiasi ambiente
axiosInstance.interceptors.request.use(config => {
  // Add the token to the header if available
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  // Sia in sviluppo che in produzione
  if (config.url && !config.url.startsWith('/api/') && !config.url.startsWith('http')) {
    // Se l'URL non inizia già con /api/ e non è un URL assoluto
    config.url = `/api${config.url}`;
  }
  return config;
});

// Response interceptor to handle authentication errors and network issues
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Controlla se l'errore è dovuto a problemi di connessione o timeout del server
    // Il ServerErrorModal dovrebbe apparire SOLO quando il server è completamente irraggiungibile
    if (!error.response) {
      // Errore di rete o timeout del server - server irraggiungibile
      const errorMessage = 'Errore di connessione al server. Riprova più tardi.';
      
      // Notifica l'applicazione dell'errore di connessione con server down
      window.dispatchEvent(new CustomEvent('serverConnectionError', {
        detail: { message: errorMessage }
      }));
      
      return Promise.reject(error);
    }
    
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Save current path before redirect (exclude login page to avoid loops)
      if (window.location.pathname !== '/login') {
        localStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);

        // Clear token on 401 error
        localStorage.removeItem('token');

        // Notify application about unauthorized access
        window.dispatchEvent(new CustomEvent('unauthorizedAccess', {
          detail: { message: error.response?.data?.message || 'Session expired' }
        }));

        // Only redirect to login if we're not already on the login page
        window.location.href = '/login';
      }
      // If we're already on login page, don't redirect, just notify about the error
      else if (window.location.pathname === '/login' && error.response.config.url.includes('/auth/login')) {
        // Still dispatch the event for error handling but don't redirect
        window.dispatchEvent(new CustomEvent('unauthorizedAccess', {
          detail: { message: error.response?.data?.message || 'Invalid credentials' }
        }));
      }
    }
    
    // Gli errori HTTP (400, 500, ecc.) vengono gestiti normalmente dai singoli componenti
    // Il ServerErrorModal appare SOLO quando il server è completamente irraggiungibile
    
    return Promise.reject(error);
  }
);

export default axiosInstance;